import React, { useEffect, useRef } from 'react';
import { View, Text, StyleSheet, Animated, SafeAreaView, TouchableOpacity } from 'react-native';
import { useToast } from '../hooks/useToast';
import { COLORS } from '../styles/commonStyles';
import CheckIcon from './icons/CheckIcon';
import WarningIcon from './icons/WarningIcon';

const Toast: React.FC = () => {
    const { toast, hideToast } = useToast();
    const translateY = useRef(new Animated.Value(-150)).current;

    useEffect(() => {
        if (toast) {
            Animated.timing(translateY, {
                toValue: 0,
                duration: 300,
                useNativeDriver: true,
            }).start();

            const timer = setTimeout(() => {
                hideToast();
            }, 4000);

            return () => clearTimeout(timer);
        } else {
            Animated.timing(translateY, {
                toValue: -150,
                duration: 300,
                useNativeDriver: true,
            }).start();
        }
    }, [toast, translateY, hideToast]);

    if (!toast) {
        return null;
    }

    const isSuccess = toast.type === 'success';
    const bgColor = isSuccess ? COLORS.success : COLORS.error;
    const Icon = isSuccess ? CheckIcon : WarningIcon;

    return (
        <Animated.View style={[styles.container, { transform: [{ translateY }] }]}>
            <SafeAreaView>
                <TouchableOpacity onPress={hideToast} activeOpacity={0.8}>
                    <View style={[styles.toast, { backgroundColor: bgColor }]}>
                        <Icon color={COLORS.white} size={24} />
                        <View style={styles.textContainer}>
                            <Text style={styles.title}>{toast.title}</Text>
                            <Text style={styles.message}>{toast.message}</Text>
                        </View>
                    </View>
                </TouchableOpacity>
            </SafeAreaView>
        </Animated.View>
    );
};

const styles = StyleSheet.create({
    container: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
    },
    toast: {
        flexDirection: 'row',
        alignItems: 'center',
        padding: 16,
        margin: 16,
        borderRadius: 12,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 8,
        elevation: 5,
    },
    textContainer: {
        marginLeft: 12,
        flex: 1,
    },
    title: {
        color: COLORS.white,
        fontWeight: 'bold',
        fontSize: 16,
    },
    message: {
        color: COLORS.white,
        fontSize: 14,
        marginTop: 2,
    },
});

export default Toast;
